import {SnackbarService, String} from "@hps/hops-react";
import React, {useEffect} from "react";

import Card from "Components/Card";
import Flex from "Components/Flex";
import dCheckoutBasketReset from "Dispatchers/dCheckoutBasketReset";

import BuildIcon from "@mui/icons-material/Build";

/**
 * Maintenance root view
 */
const MaintenanceView = () => {

	/**
	 * Clear the customer's basket - the contents might not be compatible with any future updates
	 */
	useEffect(() => {
		dCheckoutBasketReset();
		SnackbarService.snack("Your basket has been cleared because this site is currently unavailable.", "error");
	}, []);

	return (
		<Card style={{marginBottom: "3em"}}>
			<Flex justifyContent="center" alignItems="center">
				<BuildIcon color="primary" sx={{fontSize: "6em"}} />
				<String str="We'll be back soon" variant="h4" />
				<String color="textSecondary" str="This site is undergoing scheduled maintenance." />
			</Flex>
		</Card>
	);

};

export default MaintenanceView;
